export const formData = [
    {
        id: 0,
        type: 'bottomInput',
        text: 'ФИО',
        placeholder: '',
    },
    {
        id: 1,
        type: 'bottomInput',
        text: 'Дата рождения',
        placeholder: '',
    },
    {
        id: 2,
        type: 'bottomInput',
        text: 'Семейное положение',
        placeholder: '',
    },
    {
        id: 3,
        type: 'bottomInput',
        text: 'Дети',
        placeholder: '(количество/возраст)',
    },
    {
        id: 4,
        type: 'bottomInput',
        text: 'Место рождения',
        placeholder: '',
    },
    {
        id: 5,
        type: 'bottomInput',
        text: 'Прописка',
        placeholder: '',
    },
    {
        id: 6,
        type: 'bottomInput',
        text: 'Адрес проживания',
        placeholder: '',
    },
    {
        id: 7,
        type: 'bottomInput',
        text: 'Контактные телефоны',
        placeholder: '',
    },
    {
        id: 8,
        type: 'bottomInput',
        text: 'Почта',
        placeholder: '',
    },
    {
        id: 9,
        type: 'bottomInput',
        text: 'Направление деятельности, которое Вас интересует',
        placeholder: '',
    },
    {
        id: 10,
        type: 'bottomInput',
        text: 'Должностная позиция, на которую претендуете',
        placeholder: '',
    },
    {
        id: 11,
        type: 'bottomInput',
        text: 'Минимальный уровень заработной платы',
        placeholder: '',
    },
    {
        id: 12,
        type: 'select',
        text: 'Откуда Вы узнали о вакансии',
        options: [
            {
                id: 0,
                text: 'Выберите вариант',
            },
            {
                id: 1,
                text: 'через hh.ru',
            },
            {
                id: 2,
                text: 'работа России',
            },
            {
                id: 3,
                text: 'проходил практику',
            },
            {
                id: 4,
                text: 'рекомендации знакомых',
            },
            {
                id: 5,
                text: 'данные с военкомата',
            },
            {
                id: 6,
                text: 'другое',
            },
        ],
    },
    {
        id: 13,
        type: 'table',
        text: 'Образование (учебные заведения, курсы)',
        columns: [
            {
                id: 0,
                text: 'Год поступления и окончания',
            },
            {
                id: 1,
                text: 'Учебное заведение',
            },
            {
                id: 2,
                text: 'Факультет, специальность',
            },
            {
                id: 3,
                text: 'Уровень образования',
            },
            {
                id: 4,
                text: 'Город обучения',
            },
        ],
    },
    {
        id: 14,
        type: 'table',
        text: 'Сведения об общеобразовательном учреждении (школа)',
        columns: [
            {
                id: 0,
                text: 'Год поступления и окончания',
            },
            {
                id: 1,
                text: 'Общеобразовательное учреждение',
            },
            {
                id: 2,
                text: 'Город',
            },
        ],
    },
    {
        id: 15,
        type: 'select',
        text: 'Наличие военного билета',
        options: [
            {
                id: 0,
                text: 'Выберите вариант',
            },
            {
                id: 1,
                text: 'есть',
            },
            {
                id: 2,
                text: 'являюсь призывником',
            },
            {
                id: 3,
                text: 'вхожу в категорию лиц, не подлежащих призыву',
            },
        ],
    },
    {
        id: 16,
        type: 'table',
        text: 'Опыт работы',
        columns: [
            {
                id: 0,
                text: 'Период работы (м.г/м.г)',
            },
            {
                id: 1,
                text: 'Должность, место работы',
            },
            {
                id: 2,
                text: 'Город, в котором работали',
            },
            {
                id: 3,
                text: 'Причина поиска (смены) работы',
            },
        ],
    },
    {
        id: 17,
        type: 'textarea',
        text: 'Перечислите подробно все должностные обязанности, выполняемые Вами',
        placeholder: '',
    },
    {
        id: 18,
        type: 'table',
        text: 'Дополнительная информация',
        columns: [
            {
                id: 0,
                text: 'Степень владения ПК (программы)',
            },
            {
                id: 1,
                text: 'Наличие водительского удостоверения и автомобиля',
            },
            {
                id: 2,
                text: 'Судимость (есть, нет), статья',
            },
        ],
    },
    {
        id: 19,
        type: 'multiCheckbox',
        text: 'Выберите язык, которым владеете',
        variants: [
            {
                id: 0,
                text: 'татарский',
            },
            {
                id: 1,
                text: 'английский',
            },
            {
                id: 2,
                text: 'немецкий',
            },
            {
                id: 3,
                text: 'французский',
            },
            {
                id: 4,
                text: 'китайский',
            },
        ],
        max: 0,
        withInput: true,
    },
    {
        id: 20,
        type: 'table',
        text: 'Близкие родственники (жена/муж, отец, мать, братья, сестры)',
        columns: [
            {
                id: 0,
                text: 'Степень родства',
            },
            {
                id: 1,
                text: 'Ф.И.О.',
            },
            {
                id: 2,
                text: 'Дата рождения',
            },
            {
                id: 3,
                text: 'Место работы, должность',
            },
            {
                id: 4,
                text: 'Место жительства',
            },
        ],
    },
    {
        id: 21,
        type: 'table',
        text: 'Работает ли кто-то из Ваших родственников в органах государственной и муниципальной власти? если нет, поставьте минусы.',
        columns: [
            {
                id: 0,
                text: 'Степень родства',
            },
            {
                id: 1,
                text: 'Ф.И.О.',
            },
            {
                id: 2,
                text: 'Дата рождения',
            },
            {
                id: 3,
                text: 'Место работы',
            },
            {
                id: 4,
                text: 'Должность',
            },
        ],
    },
    {
        id: 22,
        type: 'textarea',
        text: 'Какой из перечисленных периодов работы внес наибольший вклад в Ваше развитие? Почему?',
        placeholder: '',
    },
    {
        id: 23,
        type: 'textarea',
        text: 'Что, по Вашему мнению, является наиболее привлекательным в работе?',
        placeholder: '',
    },
    {
        id: 24,
        type: 'textarea',
        text: 'Что, по Вашему мнению, стимулирует людей работать наиболее эффективно?',
        placeholder: '',
    },
    {
        id: 25,
        type: 'textarea',
        text: 'Почему нам стоит принять Вас на работу?',
        placeholder: '',
    },
    {
        id: 26,
        type: 'textarea',
        text: 'Опишите зоны профессиональной деятельности, в которых Вы обладаете наибольшим практическим опытом и специальными знаниями',
        placeholder: '',
    },
    {
        id: 27,
        type: 'textarea',
        text: 'Какими качествами должен обладать исполнитель для успешного выполнения своих обязанностей?',
        placeholder: '',
    },
    {
        id: 28,
        type: 'textarea',
        text: 'Какими качествами должен обладать руководитель подразделения для успешного управления своим коллективом?',
        placeholder: '',
    },
    {
        id: 29,
        type: 'textarea',
        text: 'Назовите главные недостатки руководителя, которые больше всего могут мешать эффективной работе подразделения, организации?',
        placeholder: '',
    },
    {
        id: 30,
        type: 'textarea',
        text: 'Что Вас привлекает в Исполнительном комитете г.Казани?',
        placeholder: '',
    },
    {
        id: 31,
        type: 'checkbox',
        text: 'Во время проведения переговоров, какими Вы предпочитаете пользоваться стратегиями (отметить)',
        variants: [
            {
                id: 0,
                text: 'противоборство, отстаивание своих интересов',
            },
            {
                id: 1,
                text: 'компромисс',
            },
            {
                id: 2,
                text: 'сотрудничество',
            },
            {
                id: 3,
                text: 'уступка',
            },
            {
                id: 4,
                text: 'избегание',
            },
        ],
        max: 0,
    },
    {
        id: 32,
        type: 'checkbox',
        text: 'При каких условиях Вы готовы возглавить решение задачи (отметьте 2 варианта)',
        variants: [
            {
                id: 0,
                text: 'Вы являетесь начальником в данной группе',
            },
            {
                id: 1,
                text: 'Вы точно знаете, как решать данную задачу',
            },
            {
                id: 2,
                text: 'кроме Вас больше некому взять на себя ответственность',
            },
            {
                id: 3,
                text: 'если есть более опытные коллеги, не буду мешать им руководить',
            },
            {
                id: 4,
                text: 'это дело руководителя назначать ответственных за задачу',
            },
        ],
        max: 2,
    },
    {
        id: 33,
        type: 'checkbox',
        text: 'В каком случае Вы готовы (или не готовы) отстаивать свою точку зрения, которую считаете правильной, перед вышестоящим руководством? Отметьте один вариант',
        variants: [
            {
                id: 0,
                text: 'не буду спорить, так как начальник отвечает за все',
            },
            {
                id: 1,
                text: 'выскажу свое мнение, но спорить не буду',
            },
            {
                id: 2,
                text: 'буду отстаивать, если лично отвечаю за конечный результат',
            },
            {
                id: 3,
                text: 'буду отстаивать, если не отвечаю за конечный результат, но от моего результата в значительной степени зависит успех работы',
            },
            {
                id: 4,
                text: 'буду отстаивать, чтобы не пострадала репутация организации',
            },
        ],
        max: 1,
    },
    {
        id: 34,
        type: 'textarea',
        text: 'Ваши профессиональные планы на ближайший год (3 года)?',
        placeholder: '',
    },
    {
        id: 35,
        type: 'textarea',
        text: 'Увлечения, хобби',
        placeholder: '',
    },
    {
        id: 36,
        type: 'textarea',
        text: 'Если занимаетесь(-лись) спортом, то каким?',
        placeholder: '',
    },
    {
        id: 37,
        type: 'textarea',
        text: 'Если занимаетесь(-лись) киберспортом, то в какие игры предпочитаете(-ли) играть?',
        placeholder: '',
    },
    {
        id: 38,
        type: 'checkboxAgreement',
        text: 'Я подтверждаю достоверность всего изложенного выше и не возражаю против проверки.',
        agreements: [{ id: 0, text: 'Я подтверждаю достоверность всего изложенного выше и не возражаю против проверки.' }],
        max: 1,
    },
    {
        id: 39,
        type: 'checkboxAgreement',
        text: 'Я согласен пройти оценку компетенций и не претендую на получение материалов и результатов оценки.',
        agreements: [{ id: 0, text: 'Я согласен пройти оценку компетенций и не претендую на получение материалов и результатов оценки.' }],
        max: 1,
    },
    {
        id: 40,
        type: 'checkboxAgreement',
        text: 'Я согласен на обработку персональных данных.',
        agreements: [{ id: 0, text: 'Я согласен на обработку персональных данных.' }],
        max: 1,
    },
]

export const sendInfo = {
    testName: 'Анкета №1',
}
